module.exports = __webpack_public_path__ + "img/itx-file-type-webp.af5c5332.svg";